// Cross-tab sign-out ping over a localStorage `storage` event (fires in every
// *other* tab of the same origin, never in the writer). How a tab reacts is
// provider-specific: see installCrossTabLogoutListener in each token store.

export const LOGOUT_EVENT_KEY = 'app_logout_event';

export const broadcastLogout = () => {
    localStorage.setItem(LOGOUT_EVENT_KEY, Date.now().toString());
    localStorage.removeItem(LOGOUT_EVENT_KEY);
};

// Another tab started signing out.
export const onLogoutBroadcast = (callback) => {
    if (typeof window === 'undefined') return () => { };
    const handler = (event) => {
        if (event.key === LOGOUT_EVENT_KEY && event.newValue !== null) callback(event);
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
};
